/**
 * Indicates the Customer Title.
 */
export enum Area {
  Laboratory = 0,
  Admin = 1,
  Customer = 2,
  NoArea = 3,
}
